<template>
  <div class="detail">
    <img class="mainimg" :src="require('@/assets/images/temp/store.png')" alt />
    <div class="content">
      <div class="price">
        <span>¥100</span>
        <i>¥120</i>
        <em>抢购倒计时</em>
      </div>
      <div class="title">
        <span>全车打蜡小保养套餐</span>
        <div class="counter">
          <span class="item">{{ '00' }}</span>:
          <span class="item">{{ 20 }}</span>:
          <span class="item">{{ 30 }}</span>
        </div>
      </div>
      <div class="shareline">
        <div class="enterbox">
          <p>已参与</p>
          <p>2908人</p>
        </div>
        <div class="headerbox">
          <img :src="require('@/assets/images/temp/avatar.png')" alt />
          <img :src="require('@/assets/images/temp/avatar.png')" alt />
          <img :src="require('@/assets/images/temp/avatar.png')" alt />
        </div>
        <div class="sharebtn" @click="handleShowPoster">
          <img :src="require('@/assets/images/icon/activity-share.png')" alt />
        </div>
      </div>
    </div>
    <div class="space"></div>
    <div class="actmsg">
      <div class="tit">
        <div class="line"></div>
        <div class="main">活动说明</div>
        <div class="more"></div>
      </div>
      <div class="contain">
        <p>活动时间：2014年4月24日-27日，共4天</p>
        <p>
          活动规则：活动期间，通过当当购物手机客户端成功购
          买升级换代的用户，均视为成功参与此次活动；每个用
          户只可参与一次。
          活动奖励：成功参与此次活动的用户，均可获得10元当
          当网现金券，此礼券不可转让、不可返现。
        </p>
      </div>
    </div>
    <div class="space"></div>
    <div class="actmsg">
      <div class="tit">
        <div class="line"></div>
        <div class="main">推荐门店</div>
        <div class="more">查看更多</div>
      </div>
      <div class="store-item">
        <div class="left">
          <img :src="require('@/assets/images/temp/store.png')" alt />
        </div>
        <div class="middle">
          <span class="title">
            <!-- <span class="recommend">推荐</span> -->
            <span>小拇指义桥连锁中心</span>
          </span>
          <span class="grey">
            总评分
            <i class="orange">4.8</i>
          </span>
          <span class="grey ellis">杭州市萧山区义桥镇新峡路油虎线301号</span>
          <p class="tag">
            <span>星级门店</span>
            <span>服务</span>
            <span>星级</span>
            <span>星级</span>
            <span>星级</span>
          </p>
        </div>
        <div class="right">
          <span class="store-tag">直营店</span>
          <span class="grey">1.21km</span>
        </div>
      </div>
    </div>
    <div class="space"></div>
    <div class="actmsg">
      <div class="tit">
        <div class="line"></div>
        <div class="main">更多信息</div>
        <div class="more"></div>
      </div>
    </div>
    <div class="htmls">
      <img class="mainimg" :src="require('@/assets/images/temp/store.png')" alt />
    </div>
    <div class="fixedbox">
      <div class="flexbox">
        <div class="icons">
          <div class="icon">
            <van-icon :name="require('@/assets/images/icon/activity-mine.png')" size="0.4rem" />
            <p>我的</p>
          </div>
          <div class="icon">
            <van-icon :name="require('@/assets/images/icon/activity-store.png')" size="0.4rem" />
            <p>门店</p>
          </div>
          <div class="icon">
            <van-icon
              :name="require('@/assets/images/icon/activity-icon-share.png')"
              size="0.4rem"
            />
            <p>分享</p>
          </div>
        </div>
        <div class="btn" @click="go('/Activity/OrderCheck')">立即抢购</div>
      </div>
    </div>
    <van-popup v-model="showPoster" id="popup">
      <div class="poster" v-show="!showImgurl" id="poster">
        <h3>全车打蜡洗车保养套餐</h3>
        <img :src="require('@/assets/images/temp/store.png')" alt />
        <div class="qrcodebox">
          <div class="qrcode"></div>
          <div class="price">
            <p>¥130.00</p>
            <em class="lthtext">¥130.00</em>
          </div>
        </div>
      </div>
      <img class="posterimg" :src="showImgurl" alt v-show="showImgurl" />
      <p class="longpress">长按可保存图片哦～</p>
    </van-popup>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
export default {
  name: "GetCard",
  data() {
    return {
      value: 4,
      showPoster: false,
      showImgurl: ""
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleShowPoster() {
      this.showPoster = true;
      if (this.showImgurl) {
        return;
      }
      this.$nextTick(() => {
        // this.$loading("正在生成海报");
        this.$toast.loading({
          mask: true,
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: "正在生成海报"
        });
        let targetDom = document.getElementById("poster");

        // let popup = document.getElementById("popup");
        // let top = (window.innerHeight - targetDom.clientHeight) / 2;

        html2canvas(targetDom, {
          background: "#000"
        }).then(canvas => {
          // console.log(canvas);

          let imgData = canvas.toDataURL("image/jpeg");
          setTimeout(() => {
            this.showImgurl = imgData;
            this.$loadingClose();
          }, 500);
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";

.detail {
  margin-bottom: 1.23rem;

  .mainimg {
    width: 100%;
    height: 5.63rem;
  }
  .content {
    padding: 0.27rem 0.51rem 0.53rem 0.53rem;
    .price {
      display: flex;
      align-items: baseline;
      span {
        font-size: 0.37rem;
        color: #ff8939;
      }
      i {
        font-size: 0.32rem;
        font-style: normal;
        text-decoration: line-through;
        color: #979797;
        padding-left: 0.27rem;
        flex: 1;
      }
      em {
        font-style: normal;
        color: #ff8939;
        font-size: 0.32rem;
      }
    }
    .title {
      font-size: 0.43rem;
      font-weight: bold;
      margin-top: 0.13rem;
      display: flex;
      & > span {
        flex: 1;
      }
      .counter {
        display: inline-block;
        text-align: right;
        font-weight: normal;
        color: #ff8c3e;
        .item {
          display: inline-block;
          width: 0.4rem;
          padding: 0 0.03rem;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          background-color: #ff8c3e;
          border-radius: 0.05rem;
          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
    }
    .shareline {
      margin-top: 0.13rem;
      display: flex;
      align-items: center;
      .enterbox {
        color: #979797;
        margin-right: 0.27rem;
      }
      .headerbox {
        flex: 1;
        display: flex;
        align-items: center;
        img {
          width: 0.53rem;
          height: 0.53rem;
          border-radius: 0.53rem;
          flex-grow: 0;
          &:not(:last-child) {
            margin-right: 0.13rem;
          }
        }
      }
      .sharebtn {
        width: 0.43rem;
        height: 0.43rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .tit {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    margin-top: 0.53rem;
    .line {
      width: 0.11rem;
      height: 0.37rem;
      margin-bottom: 0.05rem;
      background: @primaryColor;
    }
    .main {
      flex: 1;
      margin-left: 0.11rem;
      font-size: 0.4rem;
      font-weight: bold;
    }
    .more {
      font-size: 0.32rem;
      color: #979797;
    }
  }
  .actmsg {
    padding: 0 0.53rem 0.53rem;
    .contain {
      margin-top: 0.19rem;
      p {
        font-size: 0.37rem;
      }
    }
  }
  .htmls {
    margin-bottom: 0.43rem;
  }
  .orange {
    color: #ff8939;
  }
  .store-item {
    padding: 0.51rem 0 0 0;
    margin-left: 0;
    .flex-center();
    justify-content: space-between;
    .left {
      width: 2.13rem;
      height: 2.13rem;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .middle {
      // flex: 1;
      flex-grow: 0;

      padding: 0 6px;
      span {
        display: block;
      }
      .grey {
        font-size: 12px;
        i {
          font-style: normal;
        }
      }
      .title {
        font-weight: bold;
        font-size: 0.42rem;
        padding-bottom: 5px;
        display: flex;
        align-items: center;
        .recommend {
          padding: 0.08rem;
          margin-right: 0.13rem;
          background: #ff8c3e;
          border-radius: 0.05rem;
          color: #fff;
          height: 0.32rem;
          line-height: 0.32rem;
          font-size: 0.32rem;
          display: inline-block;
        }
      }
      .ellis {
        padding: 3px 0;
        color: #979797;
        width: 5.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tag {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1px;
        span {
          box-sizing: border-box;
          width: calc(~"25% -  4px");
          margin: 1px;
          border: 1px solid #ccc;
          color: #585858;
          border-radius: 3px;
          text-align: center;
          font-size: 10px;
        }
      }
    }
    .right {
      span {
        font-size: 10px;
      }
      .store-tag {
        background: #0096ff;
        border-radius: 3px;
        color: #fff;
        font-size: 10px;
        padding: 1px 2px;
        opacity: 0.8;
        display: block;
        margin-bottom: 3px;
        text-align: center;
      }
    }
  }
  .fixedbox {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.23rem;
    background: #fff;

    .flexbox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      padding-right: 0.27rem;
      box-sizing: border-box;
      .icons {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .icon {
          text-align: center;
          font-size: 0.32rem;
        }
      }
      .btn {
        width: 5.04rem;
        height: 0.85rem;
        background: #ffbc49;
        line-height: 0.85rem;
        font-size: 0.4rem;
        text-align: center;
        color: #fff;
        border-radius: 0.05rem;
        position: relative;
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background-color: #000;
          border: inherit;
          border-color: #000;
          border-radius: inherit;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          opacity: 0;
          content: " ";
        }
        &:active::before {
          opacity: 0.1;
        }
      }
    }
  }
  @{deep}.van-popup {
    background-color: transparent;
  }
  .poster {
    width: 7.01rem;
    height: 8.32rem;
    border-radius: 0.27rem;
    background: #fff;
    h3 {
      padding: 0.53rem 0 0.27rem;
      text-align: center;
      // font-weight: bold;
      font-size: 14px;
    }
    img {
      width: 6.24rem;
      margin: 0 auto;
      display: block;
      border-radius: 0.27rem;
    }
    .qrcodebox {
      width: 6.24rem;
      margin: 0 auto;
      padding-top: 0.53rem;
      .qrcode {
        width: 1.68rem;
        height: 1.68rem;
        background: #999;
        float: left;
        margin-left: 0.8rem;
      }
      .price {
        width: 3.76rem;
        float: left;
        text-align: center;
        p {
          font-size: 0.53rem;
          color: #ff8939;
        }
        .lthtext {
          font-size: 0.4rem;
          text-decoration: line-through;
          color: #979797;
          margin-top: 0.24rem;
          display: inline-block;
          font-style: normal;
        }
      }
    }
  }
  .posterimg {
    width: 7.01rem;
    height: 8.32rem;
    border-radius: 0.27rem;
  }
  .longpress {
    text-align: center;
    margin-top: 0.27rem;
    color: #fff;
    font-size: 0.4rem;
  }
}
</style>